export default "__VITE_ASSET__272995a4__"